export default "__VITE_ASSET__CoyAni26__"